{
  "Satışlar": "Verkoop",
  "satis": {
    "Satışlar": "Verkoop",
    "Satış Ekle": "Verkoop Toevoegen",
    "Satış Düzenle": "Verkoop Bewerken",
    "Tarih": "Datum",
    "Müşteri": "Verzekerde",
    "Sigortalı": "Verzekerde",
    "Sigorta Ettiren": "Verzekerde Door",
    "Ürün": "Product",
    "Poliçe No": "Polisnr",
    "Tutar (₺)": "Bedrag (₺)",
    "Tutar ($)": "Bedrag ($)",
    "Tutar": "Bedrag",
    "Kur": "Koers",
    "Açıklama": "Notitie",
    "Durum": "Status",
    "Ekle": "Toevoegen",
    "Filtrele": "Filteren",
    "Data Yenile": "Data Vernieuwen",
    "Onaysız": "Niet goedgekeurd",
    "Onay": "Goedgekeurd",
    "Cayma": "Herroeping",
    "Not": "Notitie",
    "İptal": "Geannuleerd",
    "Bilinmiyor": "Onbekend",
    "Kaydet": "Opslaan",
    "Güncelle": "Bijwerken",
    "Filtreleri Temizle": "Filters Wissen",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "İşlem": "Actie",
    "Ara": "Zoeken",
    "Düzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Detay": "Detail",
    "Veriler yüklenemedi": "Gegevens konden niet worden geladen",
    "Hata oluştu": "Er is een fout opgetreden",
    "Silme işlemi başarısız": "Verwijderen mislukt",
    "Satış Tipi": "Verkooptype",
    "Ödeme Şekli": "Betalingsmethode",
    "Network": "Netwerk",
    "Sağlık": "Gezondheid",
    "Doğum": "Geboorte",
    "Aktarım Tutar": "Overdrachtsbedrag (₺)",
    "Silme Onayı": "Verwijderingsbevestiging",
    "Bu kaydı silmek istediğinize emin misiniz?": "Weet u zeker dat u dit record wilt verwijderen?"
  }
}
